import React from 'react'
import './styles/Arrow.css';
function DownArrow(){
    return(
        <div className="arrow">
              <div className="arrow-body"></div>
              <div className="down-arrow-head"></div>
        </div>
      
    )
}
export default DownArrow;